import { getFontUrl } from "../utils/fontUrl";

const getColorVariable = (varName: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(varName);
};

const getIsLeadingFont = (fontStack: string, fontName: string) =>
  fontStack.split(",")[0]?.trim() === fontName;

const updateFontVariables = (fontWeight: string, fontName: string) => {
  const currentFonts = getColorVariable(`--font-${fontWeight}`);
  if (getIsLeadingFont(currentFonts, fontName)) return;
  const newFontFace = `${fontName}, ${currentFonts}`;
  document.documentElement.style.setProperty(`--font-${fontWeight}`, newFontFace);
};

const updateTitleFontVariables = (fontWeight: string, fontName: string) => {
  const currentFonts = getColorVariable(`--title-font-${fontWeight}`);
  if (getIsLeadingFont(currentFonts, fontName)) return;
  const newFontFace = `${fontName}, ${currentFonts || getColorVariable(`--font-${fontWeight}`)}`;
  document.documentElement.style.setProperty(`--title-font-${fontWeight}`, newFontFace);
};

const FONT_FORMATS: Record<string, string> = {
  woff2: "woff2",
  woff: "woff",
  ttf: "truetype",
  otf: "opentype",
};

const getFontFormat = (fontPath: string) => {
  const ext = fontPath?.split("?")?.[0]?.split(".")?.pop()?.toLowerCase() || "";
  const format = FONT_FORMATS[ext];
  return format ? ` format('${format}')` : "";
};

const addedFontFaces = new Set<string>();

export const createFontFaceStyle = (fontPath: string, fontWeight: string, isTitle = false) => {
  const fontName = (fontPath as any)?.split("/")?.pop()?.split(".")?.[0];
  const fontFaceKey = `${fontWeight?.toLowerCase()}|${fontPath}`;
  if (!addedFontFaces.has(fontFaceKey)) {
    addedFontFaces.add(fontFaceKey);
    const fontFaceStyleElement = document.createElement("style");
    fontFaceStyleElement.innerHTML = `
    @font-face {
        font-family: ${fontName};
        font-weight: ${fontWeight?.toLowerCase()};
        font-display: swap;
        src: url('${getFontUrl(fontPath)}')${getFontFormat(fontPath)};
      }
    `;
    document.head.appendChild(fontFaceStyleElement);
  }

  if (isTitle) {
    updateTitleFontVariables(fontWeight?.toLowerCase(), fontName);
  } else {
    updateFontVariables(fontWeight?.toLowerCase(), fontName);
  }
};
